import { Injectable, inject } from '@angular/core';
import { BaseApiService, PaginatedResults } from '@bo/ng-api';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { FundAccountInfo, Withdrawal, WithdrawalRequest } from '../../_interfaces/fund-account.interface';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FundAccountApiService extends BaseApiService {
  protected override http: HttpClient;

  override baseUrl: string = environment.apiRoot;
  URL_FUND_ACCOUNT_INFO: string = 'biz/fund-account-info';
  URL_WITHDRAWALS: string = 'withdrawals';
  URL_APPROVE: string = 'approve';
  URL_CANCEL: string = 'cancel';

  constructor() {
    const http = inject(HttpClient);

    super(http);

    this.http = http;
  }

  /**
   * Get banking details for business
   *
   * @return Observable<FundAccountInfo>
   */
  getFundAccountInfo() {
    return this.http.get<FundAccountInfo>(this.getUrl(this.URL_FUND_ACCOUNT_INFO, true));
  }

  /**
   * Get list of withdrawal requests
   *
   * @return Observable<PaginatedResults<Withdrawal[]>>
   * @param queryParams
   */
  getWithdrawals(queryParams: HttpParams): Observable<PaginatedResults<Withdrawal[]>> {
    const url = this.getUrl(this.URL_WITHDRAWALS, true);
    return this.http.get<Withdrawal[]>(url, { observe: 'response', params: queryParams }).pipe(
      map((res) => {
        return new PaginatedResults<Withdrawal[]>(res);
      }),
    );
  }

  /**
   * Get withdrawal detail
   *
   * @return Observable<Withdrawal>
   * @param withdrawalId
   */
  getWithdrawal(withdrawalId: string): Observable<Withdrawal> {
    const url = this.getUrl([this.URL_WITHDRAWALS, withdrawalId], true);
    return this.http.get<Withdrawal>(url);
  }

  /**
   * Request new withdrawal
   *
   * @return Observable<WithdrawalRequest>
   * @param data
   */
  createWithdrawalRequest(data: WithdrawalRequest): Observable<WithdrawalRequest> {
    const url = this.getUrl(this.URL_WITHDRAWALS, true);
    return this.http.post<WithdrawalRequest>(url, data);
  }

  /**
   * Send OTP to approve withdrawal
   *
   * @param withdrawalId
   * @param code
   */
  sendWithdrawalOTP(withdrawalId: string, code: string) {
    const url = this.getUrl([this.URL_WITHDRAWALS, withdrawalId, this.URL_APPROVE], true);
    return this.http.post(url, { code: code });
  }

  /**
   * Cancel withdrawal request
   *
   * @param withdrawalId
   */
  cancelWithdrawal(withdrawalId: string) {
    const url = this.getUrl([this.URL_WITHDRAWALS, withdrawalId, this.URL_CANCEL], true);
    return this.http.post(url, {});
  }
}
